// extracted by mini-css-extract-plugin
export default {"promosTable":"styles_promosTable__ZxvVe","table":"styles_table__7tEx2","promoHeadline":"styles_promoHeadline__K3JoK","icon":"styles_icon__9z8i+","date":"styles_date__q68SK"};